import styled from 'styled-components';

import {
    Link
} from 'react-router-dom';


/*
========================================
HELPERS COLOR INVITACIÓN
========================================
*/

const colorEstadoInvitacion = (
    tipo
) => {

    switch (
        tipo
    ) {

        case 'exito':

            return '#23AAAF';


        case 'advertencia':

            return '#B78300';


        case 'error':

            return '#D76970';


        case 'info':

            return '#655EE8';


        default:

            return '#646464';

    }

};


const fondoEstadoInvitacion = (
    tipo
) => {

    switch (
        tipo
    ) {

        case 'exito':

            return 'rgba(35, 170, 175, 0.08)';


        case 'advertencia':

            return 'rgba(239, 195, 64, 0.12)';


        case 'error':

            return 'rgba(215, 105, 112, 0.08)';


        case 'info':

            return 'rgba(101, 94, 232, 0.07)';


        default:

            return 'rgba(100, 100, 100, 0.055)';

    }

};


const bordeEstadoInvitacion = (
    tipo
) => {

    switch (
        tipo
    ) {

        case 'exito':

            return 'rgba(35, 170, 175, 0.25)';


        case 'advertencia':

            return 'rgba(239, 195, 64, 0.34)';


        case 'error':

            return 'rgba(215, 105, 112, 0.28)';


        case 'info':

            return 'rgba(101, 94, 232, 0.24)';


        default:

            return 'rgba(100, 100, 100, 0.16)';

    }

};


/*
========================================
PÁGINA
========================================
*/

export const PaginaPaciente = styled.main`

    width:
        min(
            1060px,
            calc(100% - 34px)
        );

    margin:
        0 auto;

    padding:
        24px 0 45px;


    *,
    *::before,
    *::after {

        box-sizing:
            border-box;

    }


    @media (max-width: 700px) {

        width:
            calc(100% - 20px);

        padding:
            18px 0 35px;

    }

`;


/*
========================================
LAYOUT
========================================
*/

export const GridPaciente = styled.div`

    display:
        grid;

    grid-template-columns:
        minmax(
            320px,
            0.76fr
        )
        minmax(
            0,
            1.24fr
        );

    align-items:
        start;

    gap:
        24px;


    @media (max-width: 850px) {

        grid-template-columns:
            1fr;

        gap:
            18px;

    }

`;


/*
========================================
COLUMNA IZQUIERDA
========================================
*/

export const ColumnaResumen = styled.div`

    min-width:
        0;

`;


/*
========================================
TARJETAS
========================================
*/

export const TarjetaPaciente = styled.section`

    width:
        100%;

    min-width:
        0;

    padding:
        20px;

    border:
        1px solid
        rgba(
            35,
            170,
            175,
            0.25
        );

    border-radius:
        15px;

    background:
        #FFFFFF;

    box-shadow:
        0 4px 16px
        rgba(
            0,
            0,
            0,
            0.035
        );


    @media (max-width: 520px) {

        padding:
            16px;

    }

`;


/*
========================================
CABECERA TARJETA
========================================
*/

export const CabeceraTarjetaPaciente = styled.div`

    display:
        flex;

    align-items:
        flex-start;

    justify-content:
        space-between;

    gap:
        14px;

    margin-bottom:
        17px;

`;


export const BloqueTituloPaciente = styled.div`

    min-width:
        0;

`;


export const TituloTarjetaPaciente = styled.h2`

    margin:
        0;

    color:
        #23AAAF;

    font-size:
        1.05rem;

    font-weight:
        800;

    line-height:
        1.25;

`;


export const TextoTarjetaPaciente = styled.p`

    margin:
        4px 0 0;

    color:
        #646464;

    font-size:
        0.74rem;

    line-height:
        1.4;

`;


/*
========================================
EDITAR PERFIL
========================================
*/

export const BotonEditarPaciente = styled(Link)`

    flex:
        0 0 auto;

    min-height:
        36px;

    padding:
        7px 12px;

    display:
        inline-flex;

    align-items:
        center;

    justify-content:
        center;

    border:
        1px solid
        rgba(
            101,
            94,
            232,
            0.30
        );

    border-radius:
        8px;

    background:
        rgba(
            101,
            94,
            232,
            0.05
        );

    color:
        #655EE8;

    font-size:
        0.75rem;

    font-weight:
        750;

    text-decoration:
        none;

    white-space:
        nowrap;

    transition:
        0.15s ease;


    &:hover {

        background:
            rgba(
                101,
                94,
                232,
                0.11
            );

    }

`;


export const BotonEditarPacienteDeshabilitado = styled.div`

    flex:
        0 0 auto;

    min-height:
        36px;

    padding:
        7px 12px;

    display:
        inline-flex;

    align-items:
        center;

    justify-content:
        center;

    border:
        1px solid
        rgba(
            100,
            100,
            100,
            0.18
        );

    border-radius:
        8px;

    background:
        #F2F3F3;

    color:
        #999999;

    font-size:
        0.75rem;

    font-weight:
        700;

`;


/*
========================================
DATOS PACIENTE
========================================
*/

export const DatosPaciente = styled.div`

    display:
        grid;

    grid-template-columns:
        repeat(
            2,
            minmax(
                0,
                1fr
            )
        );

    gap:
        8px;


    @media (max-width: 450px) {

        grid-template-columns:
            1fr;

    }

`;


export const DatoPaciente = styled.div`

    min-width:
        0;

    padding:
        11px 12px;

    border-radius:
        9px;

    background:
        #F6F9F9;


    ${
        props =>
            props.$completo
                ?
                `
                    grid-column:
                        1 / -1;
                `
                :
                ''
    }


    @media (max-width: 450px) {

        grid-column:
            1 / -1;

    }

`;


export const LabelDatoPaciente = styled.div`

    margin-bottom:
        3px;

    color:
        #23AAAF;

    font-size:
        0.66rem;

    font-weight:
        800;

    text-transform:
        uppercase;

    letter-spacing:
        0.025em;

`;


export const ValorDatoPaciente = styled.div`

    color:
        #3F3F3F;

    font-size:
        0.82rem;

    font-weight:
        600;

    line-height:
        1.35;

    overflow-wrap:
        anywhere;

`;


/*
========================================
INVITACIÓN A LA PLATAFORMA
========================================
*/

export const BloqueInvitacion = styled.div`

    margin-top:
        14px;

    padding:
        13px 14px;

    border:
        1px solid
        ${
            props =>
                bordeEstadoInvitacion(
                    props.$tipo
                )
        };

    border-radius:
        10px;

    background:
        ${
            props =>
                fondoEstadoInvitacion(
                    props.$tipo
                )
        };

`;


export const CabeceraInvitacion = styled.div`

    display:
        flex;

    align-items:
        center;

    justify-content:
        space-between;

    flex-wrap:
        wrap;

    gap:
        8px;

`;


export const TituloInvitacion = styled.div`

    color:
        #3F3F3F;

    font-size:
        0.76rem;

    font-weight:
        800;

`;


export const EstadoInvitacion = styled.div`

    padding:
        4px 8px;

    border:
        1px solid
        ${
            props =>
                bordeEstadoInvitacion(
                    props.$tipo
                )
        };

    border-radius:
        999px;

    background:
        #FFFFFF;

    color:
        ${
            props =>
                colorEstadoInvitacion(
                    props.$tipo
                )
        };

    font-size:
        0.63rem;

    font-weight:
        800;

    line-height:
        1.2;

    white-space:
        nowrap;

`;


export const EmailInvitacion = styled.div`

    margin-top:
        8px;

    color:
        #3F3F3F;

    font-size:
        0.73rem;

    font-weight:
        700;

    overflow-wrap:
        anywhere;

`;


export const TextoInvitacion = styled.div`

    margin-top:
        5px;

    color:
        #646464;

    font-size:
        0.69rem;

    line-height:
        1.45;

`;


export const VigenciaInvitacion = styled.div`

    margin-top:
        6px;

    color:
        #646464;

    font-size:
        0.65rem;

    font-weight:
        650;

`;


/*
========================================
SEPARADOR
========================================
*/

export const SeparadorPaciente = styled.div`

    width:
        100%;

    height:
        1px;

    margin:
        18px 0;

    background:
        rgba(
            100,
            100,
            100,
            0.11
        );

`;


/*
========================================
MÉTODO YÖGEN
========================================
*/

export const BotonMetodo = styled.button`

    width:
        100%;

    min-height:
        43px;

    padding:
        9px 14px;

    border:
        1px solid
        ${
            props =>
                props.$deshabilitado
                    ?
                    '#D6D6D6'
                    :
                    '#FC8906'
        };

    border-radius:
        10px;

    background:
        ${
            props =>
                props.$deshabilitado
                    ?
                    '#EEEEEE'
                    :
                    '#FC8906'
        };

    color:
        ${
            props =>
                props.$deshabilitado
                    ?
                    '#909090'
                    :
                    '#FFFFFF'
        };

    font-family:
        inherit;

    font-size:
        0.78rem;

    font-weight:
        800;

    cursor:
        ${
            props =>
                props.$deshabilitado
                    ?
                    'default'
                    :
                    'pointer'
        };

    transition:
        0.15s ease;


    &:hover {

        ${
            props =>
                !props.$deshabilitado
                    ?
                    `
                        transform:
                            translateY(-1px);

                        box-shadow:
                            0 4px 12px
                            rgba(
                                252,
                                137,
                                6,
                                0.20
                            );
                    `
                    :
                    ''
        }

    }

`;


export const BotonMetodoLink = styled(Link)`

    width:
        100%;

    min-height:
        43px;

    padding:
        9px 14px;

    display:
        flex;

    align-items:
        center;

    justify-content:
        center;

    border:
        1px solid
        #FC8906;

    border-radius:
        10px;

    background:
        #FC8906;

    color:
        #FFFFFF;

    font-size:
        0.78rem;

    font-weight:
        800;

    text-align:
        center;

    text-decoration:
        none;

    transition:
        0.15s ease;


    &:hover {

        transform:
            translateY(-1px);

        box-shadow:
            0 4px 12px
            rgba(
                252,
                137,
                6,
                0.20
            );

    }

`;


/*
========================================
CONFIGURACIÓN
========================================
*/

export const ConfiguracionInferior = styled.div`

    margin-top:
        15px;

    display:
        flex;

    align-items:
        center;

    justify-content:
        center;

    flex-wrap:
        wrap;

    gap:
        10px 18px;

`;


export const ConfiguracionInlineItem = styled.div`

    display:
        flex;

    align-items:
        center;

    gap:
        7px;

`;


export const ConfiguracionInlineLabel = styled.span`

    color:
        #646464;

    font-size:
        0.72rem;

    font-weight:
        650;

`;


export const BotonConfiguracion = styled.button`

    min-height:
        30px;

    padding:
        5px 11px;

    border:
        1px solid
        rgba(
            35,
            170,
            175,
            0.30
        );

    border-radius:
        999px;

    background:
        rgba(
            35,
            170,
            175,
            0.07
        );

    color:
        #148A8E;

    font-family:
        inherit;

    font-size:
        0.70rem;

    font-weight:
        750;

    cursor:
        pointer;

    transition:
        0.15s ease;


    &:hover {

        background:
            rgba(
                35,
                170,
                175,
                0.13
            );

    }

`;


/*
========================================
ACCESOS
========================================
*/

export const GridAccesos = styled.div`

    width:
        100%;

    min-width:
        0;

    display:
        grid;

    grid-template-columns:
        repeat(
            2,
            minmax(
                0,
                1fr
            )
        );

    gap:
        10px;


    @media (max-width: 500px) {

        grid-template-columns:
            1fr;

    }

`;


const estilosAcceso = `

    box-sizing:
        border-box;

    width:
        100%;

    min-width:
        0;

    min-height:
        47px;

    padding:
        8px 12px;

    display:
        flex;

    align-items:
        center;

    justify-content:
        center;

    border-radius:
        9px;

    font-family:
        inherit;

    font-size:
        0.76rem;

    font-weight:
        700;

    line-height:
        1.25;

    text-align:
        center;

    text-decoration:
        none;

    transition:
        0.15s ease;

`;


export const BotonAcceso = styled.button`

    ${estilosAcceso}

    border:
        1px solid
        ${
            props =>
                props.$deshabilitado
                    ?
                    'rgba(100, 100, 100, 0.20)'
                    :
                    'rgba(35, 170, 175, 0.30)'
        };

    background:
        ${
            props =>
                props.$deshabilitado
                    ?
                    '#E4E6E6'
                    :
                    '#FFFFFF'
        };

    color:
        ${
            props =>
                props.$deshabilitado
                    ?
                    '#747474'
                    :
                    '#3F3F3F'
        };

    cursor:
        ${
            props =>
                props.$deshabilitado
                    ?
                    'default'
                    :
                    'pointer'
        };


    &:hover {

        ${
            props =>
                !props.$deshabilitado
                    ?
                    `
                        border-color:
                            #23AAAF;

                        background:
                            rgba(
                                35,
                                170,
                                175,
                                0.07
                            );
                    `
                    :
                    ''
        }

    }

`;


export const BotonAccesoLink = styled(Link)`

    ${estilosAcceso}

    border:
        1px solid
        ${
            props =>
                props.$deshabilitado
                    ?
                    'rgba(100, 100, 100, 0.20)'
                    :
                    'rgba(35, 170, 175, 0.30)'
        };

    background:
        ${
            props =>
                props.$deshabilitado
                    ?
                    '#E4E6E6'
                    :
                    '#FFFFFF'
        };

    color:
        ${
            props =>
                props.$deshabilitado
                    ?
                    '#747474'
                    :
                    '#3F3F3F'
        };

    pointer-events:
        ${
            props =>
                props.$deshabilitado
                    ?
                    'none'
                    :
                    'auto'
        };


    &:hover {

        ${
            props =>
                !props.$deshabilitado
                    ?
                    `
                        border-color:
                            #23AAAF;

                        background:
                            rgba(
                                35,
                                170,
                                175,
                                0.07
                            );
                    `
                    :
                    ''
        }

    }

`;


/*
========================================
ESTADÍSTICAS
========================================
*/

export const AccesoAncho = styled.div`

    width:
        100%;

    min-width:
        0;

    grid-column:
        1 / -1;


    > a {

        width:
            100%;

    }


    @media (max-width: 500px) {

        grid-column:
            auto;

    }

`;


/*
========================================
AVISO MÉTODO
========================================
*/

export const AvisoMetodo = styled.div`

    margin-top:
        12px;

    padding:
        9px 11px;

    border:
        1px solid
        rgba(
            239,
            195,
            64,
            0.32
        );

    border-radius:
        8px;

    background:
        rgba(
            239,
            195,
            64,
            0.09
        );

    color:
        #646464;

    font-size:
        0.70rem;

    line-height:
        1.4;

    text-align:
        center;

`;


/*
========================================
PROFESIONAL NO SUSCRIPTO
========================================
*/

export const TextoNoSuscripto = styled.div`

    ${estilosAcceso}

    border:
        1px solid
        rgba(
            100,
            100,
            100,
            0.20
        );

    background:
        #E4E6E6;

    color:
        #747474;

`;